import React from 'react';
import { connect } from 'react-redux';
import Translate from 'translate';
import { Form } from 'react-form';
import moment from 'moment';

import Table from 'components/HTMLElements/Table/Custom';
import { toggleAlertError, toggleLoading } from 'stores/actions/';
import ReportService from 'services/ReportService';
import { FormGroup, InputDate, Select } from 'components/FormElements';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import NavigationExpandMoreIcon from 'material-ui/svg-icons/file/file-download';
import MenuItem from 'material-ui/MenuItem';
import _ from 'lodash';

class EntriesBycategory extends React.Component {
  constructor(props) {
    super(props);
    this.date = new Date();
    this.orderby = 'orderBy[total]';
    this.desc = true
    this.firstDay = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
    this.state = {
      data: [],
      dateFrom: this.firstDay,
      dateTo: new Date(),
      deleteModalOpened: false,
      sourceId: 0,
      sources: [ ],
    };
    this.download = '';
    this.search = {};
    this.getData = this.getData;
  }
  componentDidMount() {
    const {chatActive, phoneActive} = this.props;
    let sources = [        
      {id:'facebook',name:'facebook'},
      {id:'twitter',name:'twitter'},
      {id:'email',name:'email'},
      {id:'walk_in',name:'walkin'},
    ];

    if (chatActive){
      sources.push( {id:'chat',name:'chat'})
    }

    if (phoneActive){
      sources.push( {id:'phone',name:'phone'})
    }
    this.setState({sources});
    this.getReport(this.params);
  }
  getReport(params) {
    const { isLoading, toggleLoading } = this.props;
    this.params = _.cloneDeep(params);

    if (!isLoading) toggleLoading(true);
    const apiParams = {
      dateFrom: moment(this.state.dateFrom).format('YYYY-MM-DD') ,
      dateTo: moment(this.state.dateTo).format('YYYY-MM-DD'),
      
      
    };
    if (this.download !== '' ) {
      apiParams.download = this.download
    }

    if (this.state.sourceId !== 0 ) {
      apiParams.types = this.state.sourceId
    }

    apiParams[this.orderby] = this.desc  ? 'desc' : 'asc',
    ReportService.getReportsEntriesPerCategory(apiParams).then(response => {
      
      if (this.download !== '') {
        toggleLoading(false);
        this.download = '';
        window.location.href = response.data.uri;

      } else {
        if (response.data) {
          this.setState({
            data: response.data
          });
        }
        toggleLoading(false);
      }
    });
  }
  handleChange = e => {
    this.setState({ sourceId: e.target.value });
  };

  handleChangeSource = e => {
    let x = []
    _.map( e, ( item, index ) => {
      //console.log( _.get( item, 'id' ) );
      x[index]=_.get( item, 'id' )

    });
    this.setState({ sourceId: x});
  };

  handleDateChangeDateFrom = e => {
    this.setState({ dateFrom: e });
  };

  handleDateChangeDateTo = e => {
    this.setState({ dateTo: e });
  };

  submitForm = data => {
    this.search = data;
    //this.getReport(this.params);
  };
  onSortChange = order => {
    if (order[0].id==='AMOUNT') {
      this.orderby = 'orderBy[total]';
      this.desc = order[0].desc ;
    } else {
      this.orderby = 'orderBy[category]';
      this.desc = order[0].desc ;
      
    }
    //  console.log(this.orderby , '  ', this.desc);
    // this.getReport(this.params)
  }
  render() {
    const { data, dateFrom, dateTo, sources, sourceId } = this.state;
    return (
      <div className="box box-default">
        <div className="box-header d-flex justify-content-between">
          <h4>
            <Translate id="report.entriesByCategory" />
          </h4>
        </div>
        <div>
          <Form onSubmit={this.submitForm}>
            {({ submitForm }) => (
              <form onSubmit={submitForm} className="d-flex">
                
                <FormGroup containerClass="col-md-3" >


                  <label className={'MuiFormLabel-root MuiInputLabel-shrink'} style={{marginBottom:'0rem'}}><Translate id="report.source"/></label>
                  <Select field="sourceId" className="form-control" 
                          placeholder={<Translate id="report.selectSource" />}
                          labelKey="name"
                          valueKey="id"
                          simpleValue={false} multi 
                          onChange={this.handleChangeSource}
                          options={sources}/>

                </FormGroup>
                <FormGroup containerClass="col-md-3">
                  <InputDate
                    label={<Translate id="report.dateFrom" />}
                    value={dateFrom}
                    onChange={this.handleDateChangeDateFrom}
                  />
                </FormGroup>

                <FormGroup containerClass="col-md-3">
                  <InputDate
                    label={<Translate id="report.dateTo" />}
                    value={dateTo}
                    onChange={this.handleDateChangeDateTo}
                  />
                </FormGroup>

                <div className="col-md-2 pl-0">
                  <button
                    style={{ marginTop: '15px', marginLeft: '-50px' }}
                    type="submit"
                    className="btn btn-info mr-2 px-3"
                    onClick={() => {
                      this.search = {};
                      this.download = '';
                      this.getReport(
                        moment(dateFrom).format('DD-MM-YYYY'),
                        moment(dateTo).format('DD-MM-YYYY')
                      );
                    }}
                  >
                    <i className="fa fa-search pointer" />
                  </button>
                </div>

                <div className="col-md-1 pl-0 text-right">


                  <IconMenu style={{ height: '20px' }}
                        iconButtonElement={
                          <IconButton touch className="btn-account">
                            <NavigationExpandMoreIcon/>
                          </IconButton>
                        }>
                  <MenuItem
                    onClick={() => {
                      this.search = {};
                      this.download = 'excel';
                      this.getReport(
                        moment(dateFrom).format('DD-MM-YYYY'),
                        moment(dateTo).format('DD-MM-YYYY')
                      );
                    }}
                    key={1}
                    style={{ lineHeight: '25px', fontSize: '14px', minHeight: 'unset' }}
                    primaryText={''}> 
                    <i className="fa fa-file-excel-o pointer" /> CSV 
                  </MenuItem>
                  {/*<MenuItem
                    onClick={() => {
                      this.search = {};
                      this.download = 'pdf';
                      this.getReport(
                        value,
                        moment(dateFrom).format('DD-MM-YYYY'),
                        moment(dateTo).format('DD-MM-YYYY')
                      );
                    }}
                    key={2}
                    style={{ lineHeight: '25px', fontSize: '14px', minHeight: 'unset' }}
                    primaryText={''}> 
                    <i className="fa fa-file-pdf-o pointer" /> Pdf
                  </MenuItem>
                  */}
                  </IconMenu>
                </div>
              </form>
            )}
          </Form>
          <div className="box-body">
            <Table
              className="app-table-report"
              data={data}
              onSortedChange={this.onSortChange.bind(this)}
              columns={[
                {
                  Header: <Translate id="report.category" />,
                  accessor: 'CATEGORY',
                  Cell: props => ( props.value ? props.value: <Translate id="report.otherCategory" /> ),
                },
                {
                  Header: <Translate id="report.total" />,
                  accessor: 'AMOUNT',
                  Cell: props => props.value,
                  sortMethod: (a, b) => {
                    a=parseInt(a);
                    b=parseInt(b);
                    if (a === b) {
                      return 0;
                    }
                    return a > b ? 1 : -1;
                  }

                  
                },

              ]}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.settings.isLoading,
  chatActive: state.settings.chatActive,
  phoneActive: state.settings.phoneActive,
});

const mapDispatchToProps = dispatch => ({
  toggleAlertError: message => {
    dispatch(toggleAlertError(message));
  },
  toggleLoading: isLoading => {
    dispatch(toggleLoading(isLoading));
  }
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(EntriesBycategory);



// WEBPACK FOOTER //
// ./routes/app/routes/reports/EntriesByCategory/index.js